<template>
  <div class="dropdown-select" :class="{'disabled-active': current.disabled}">
    <a class="dropdown-link form-control" type="button" :class="{disabled}" data-bs-toggle="dropdown">
      <span class="current-value">{{ current.name }}</span>
      <span class="ic-arrow-down"></span>
    </a>
    <ul class="dropdown-menu">
      <li v-for="(item, index) in options" :key="index" @click="dropDownClick(item)">
        <a class="dropdown-item" :class="classList(item)">{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "DropDownSelect",
  props: {
    options: {
      type: Array,
      required: true,
      validator(value) {
        return !value.find(i => (
          !Object.prototype.hasOwnProperty.call(i, 'name') ||
          !Object.prototype.hasOwnProperty.call(i, 'value')
        ))
      }
    },
    defaultText: {
      default: 'Не выбрано'
    },
    modelValue: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean
    }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    current() {
      return this.options.find(i => i.value === this.modelValue)
        || {name: this.defaultText, value: undefined}
    }
  },
  methods: {
    dropDownClick({value, disabled = false}) {
      if (!disabled) {
        this.$emit('update:modelValue', value)
      }
    },
    classList(option) {
      return {
        active: option === this.current,
        disabled: option.disabled || false
      }
    },
  },
  watch:{
    current(){
      this.$emit('change')
    }
  }
}
</script>

<style scoped lang="scss">
.dropdown-select {
  display: block;
  position: relative;
  width: 100%;

  .dropdown-link {
    width: 100%;
    padding-right: 40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    text-decoration: none;


    &:hover, &:active, &:focus {
      box-shadow: 0 0;
      color: inherit;
    }

    .ic-arrow-down {
      position: absolute;
      right: 12px;
      top: 10px;
      font-size: 1.3rem;
      transition: 200ms;

      &:hover {
        color: var(--default-icon-color);
      }
    }

    &.disabled{
      background-color: #eee;
      color: #777;
      cursor: default;
    }

    &[aria-expanded="true"] .ic-arrow-down {
      transform: rotate(180deg);
    }
  }
  .dropdown-menu {
    min-width: 100%;
    padding: 0;
    box-shadow: var(--common-content-box-shadow);
    border-radius: 20px;
    overflow: hidden;

    .dropdown-item {
      cursor: pointer;
      user-select: none;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding: 8px 15px;

      &:last-child{
        border-bottom: none;
      }

      &.active {
        color: var(--common-button);
        background: transparent;
      }

      &:active, &:hover {
        color: inherit;
        background: var(--common-table-row-background);
      }
    }
  }

  .selected {
    background: var(--common-background-frame);
  }

}


</style>
